import clsx from 'clsx';

import './logo.scss';

export const Logo = (props: LogoProps) => {
  const { appearance = 'default', ...rest } = props;

  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('logo', `l-a-${appearance}`)}
      {...rest}
    >
      <path
        d="M12.9526 100C11.2826 100 9.87153 99.4325 8.72333 98.2995C7.57513 97.1665 7 95.774 7 94.1262V69.5914C8.20777 62.7792 12.6404 57.8925 18.7901 55.3123C31.673 49.9068 52.4042 53.1659 61.4727 61.1861L18.1246 6.52438C17.3975 5.83526 16.9456 4.8644 16.9456 3.78613C16.9456 1.72686 18.5991 0.0526977 20.6613 0H20.7579H49.6826C107.44 0 107.44 100 49.6826 100H12.9526Z"
        fill="currentColor"
      />
      <path
        d="M32.7532 24.9706L18.1244 6.52235C17.3973 5.83323 16.9454 4.86238 16.9454 3.7841C16.9454 1.72686 18.5989 0.0526977 20.6612 0H20.7577H49.6825C83.6376 0 97.6215 34.5596 91.6525 63.0467C90.5453 33.1651 55.6371 46.2868 32.7532 24.9706Z"
        fill="currentColor"
      />
      <path
        d="M65.5008 71.3042C65.5193 71.6001 65.5275 71.9001 65.5275 72.2001C65.5275 82.6018 54.7192 91.2199 40.6121 92.74L18.7902 55.3125C31.9072 49.2684 52.1948 52.0716 61.4523 61.168C63.7836 63.9549 65.2625 67.3316 65.5008 71.3042Z"
        fill="currentColor"
      />
    </svg>
  );
};

interface LogoProps {
  appearance?: 'default' | 'greyscale';
}
